import Vue from 'vue'
import App from './App.vue'
import './_plugins/axios'
import store from './_store'
import router from './_router'
import vuetify from './_plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
